<template>
    <div class="container">
      <busqueda-en-fecha @seleccionada="onBusquedaEnFecha" />
      <div class="charts-container">
        <graficos-ventas-ciudad :fecha="fechaSeleccionada" />
        <graficos-vendidos :fecha="fechaSeleccionada" />
      </div>
    </div>
  </template>
  
  
  <script>
  import BusquedaEnFecha from "../Extras/BusquedaEnFecha.vue";
  import GraficosVentasCiudad from "./GraficosVentasCiudad.vue";
  import GraficosVendidos from "./GraficosVendidos.vue";
  export default {
    components: { GraficosVentasCiudad, BusquedaEnFecha,GraficosVendidos },
    name: "InformeVentas",
    data() {
      return {
        fechaSeleccionada: [], // Guarda las fechas seleccionadas
      };
    },
    methods: {
      onBusquedaEnFecha(fechas) {
        this.fechaSeleccionada = fechas; // Actualiza las fechas seleccionadas
      },
    },
  };
  </script>
  
  <style scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.charts-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.charts-container > * {
  flex: 1;
  margin: 0 10px; /* Ajusta el margen si es necesario */
}

.charts-container > *:first-child {
  margin-left: 0; /* Elimina el margen izquierdo del primer gráfico */
}

.charts-container > *:last-child {
  margin-right: 0; /* Elimina el margen derecho del último gráfico */
}
</style>

  